import React, { useState } from 'react';

import Select from 'react-select';
import { Label } from './style';

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        cursor: "pointer",
        padding: "0.8rem",
        border: "2px solid #eee",
        borderRadius: "8px",
        marginBottom: "2rem",
    }),
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? '#fff' : 'black',
        cursor: "pointer",
        background: state.isSelected ? '#FA578E' : '#fff',
        "&:hover": {
            color: '#fff',
            background: '#fb78a4'
        }
    })
};



const options = [
    { value: 'New York City', label: 'New York City'},
    { value: 'Chicago', label: 'Chicago'},
    { value: 'Detroit', label: 'Detroit'},
    { value: 'Los Angeles', label: 'Los Angeles'},
];

const StyledSelect = ({ label, onChange }) => {
    const [option, setOption] = useState({ value: 'New York City', label: 'New York City'});

    const handleChange = (option) => {
        setOption(option);
        onChange(option.value);
    }

    return ( 
        <>
            <Label htmlFor="select">{label}</Label>
            <Select
                id="select"
                styles={customStyles}
                value={option}
                onChange={handleChange}
                options={options}
            />
        </>
    );
};

export default StyledSelect;